module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/e740c51bb099110dff2900fa4fc94d72.png";